import React from 'react';
import PropTypes from 'prop-types';

import ManagedInput from 'components/form/managed_input';
import { Modal } from 'react-bootstrap';

export default class DeleteGroupsModal extends React.Component {
  static propTypes = {
    groups: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })),
    shown: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
  }

  state = {
    selectedGroupIds: []
  }

  componentDidUpdate(previousProps) {
    if (this.props.shown && !previousProps.shown) {
      this.setState({ selectedGroupIds: this.props.groups.map(group => group.id) });
    }
  }

  handleSelectionChange = (changes) => {
    const id = parseInt(Object.keys(changes)[0]);
    const checked = changes[id];

    if (checked) {
      this.setState(state => ({ selectedGroupIds: [...state.selectedGroupIds, id] }));
    } else {
      this.setState(state => ({ selectedGroupIds: state.selectedGroupIds.filter(groupId => groupId !== id) }));
    }
  }

  handleDelete = () => {
    const groups = this.props.groups.filter(group => this.state.selectedGroupIds.includes(group.id));
    this.props.onDelete(groups);
  };

  render() {
    const groupWord = this.props.groups && this.props.groups.length === 1 ? 'Group' : 'Groups';

    return (
      <Modal show={this.props.shown} onHide={this.props.onCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Delete {groupWord}</Modal.Title>
        </Modal.Header>

        <Modal.Body className="ml-2">
          <div className="mb-2">You are about to delete the following {groupWord}:</div>
          {this.renderGroups()}
          <div className="mt-2">This action is permanent. Are you sure you want to delete?</div>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-sm btn-cancel"
            name="cancel"
            onClick={this.props.onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-sm btn-danger"
            disabled={this.state.selectedGroupIds.length === 0}
            name="delete"
            onClick={this.handleDelete}
          >
            Delete {groupWord}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderGroups() {
    return this.props.groups && this.props.groups.map(this.renderGroup);
  }

  renderGroup = (group) => {
    return (
      <div key={group.id}>
        {this.props.groups.length === 1 ? <strong>{group.name}</strong> : (
          <ManagedInput
            checked={this.state.selectedGroupIds.includes(group.id)}
            name={group.id.toString()}
            type="checkbox"
            onChange={this.handleSelectionChange}
          >
            <strong>{group.name}</strong>
          </ManagedInput>
        )}
      </div>
    );
  }
}
